export const isAdmin = (user) => user?.role === 'ADMIN';
export const isAdminOrAccountant = (user) => user?.role === 'ADMIN' || user?.role === 'ACCOUNTANT';
